//--------------- IMPORTAÇÕES ---------------//
import { LoadingContext } from "../../../shared/context/LoadingContext";
import { UsuariosContext } from "../context/UsuariosContext";
import { enableUserService, disableUserService, loadUsersService } from "../services";
import { useContext } from "react";



//--------------- EXPORTAÇÃO DO COMPONENTE CONTAINER CREATE COMPANY ---------------//
export default function TableUsers() {



    //--------------- CRIAÇÃO DOS HOOKS ---------------//
    const { status, setStatus } = useContext(UsuariosContext);
    const { users, setUsers } = useContext(UsuariosContext);
    const { formData, setFormData } = useContext(UsuariosContext);
    const { isEditing, setIsEditing } = useContext(UsuariosContext);
    const { userIdEdited, setUserIdEdited } = useContext(UsuariosContext);
    const { passwordOnly, setPasswordOnly } = useContext(UsuariosContext);
    const { isModalOpen, setIsModalOpen } = useContext(UsuariosContext);
    const { isLoading, setIsLoading } = useContext(LoadingContext);



    //-------------- FUNÇÃO ASSÍNCRONA HANDLE REFRESH USERS --------------//
    // Responsável por requisitar os usuário à API
    async function handleRefreshUsers() {
        setIsLoading(true);
        const response = await loadUsersService(status);
        if (response) {
            setUsers(response.data);
        }
        setIsLoading(false);
    };



    //-------------- FUNÇÃO ABRIR MODAL --------------//
    function handleOpenModal(usuario = null, apenasSenha = false) {
        if (usuario) {
            setFormData({
                nome: usuario.nome,
                email: usuario.email,
                senha: ""
            });
            setIsEditing(true);
            setUserIdEdited(usuario.id);
            setPasswordOnly(apenasSenha);
        } else {
            setFormData({
                nome: "",
                email: "",
                senha: ""
            });
            setIsEditing(false);
            setUserIdEdited(null);
            setPasswordOnly(false);
        }
        setIsModalOpen(true);
    };



    //-------------- FUNÇÃO ASSÍNCRNA INATIVAR USUÁRIO --------------//
    // Responsável por tornar "false" o atributo "ativo" do usuário via API
    async function handleDisableUser(id) {
        const response = await disableUserService(id);
        if (response) {
            handleRefreshUsers();
        }
    };



    //-------------- FUNÇÃO ASSÍNCRNA INATIVAR USUÁRIO --------------//
    // Responsável por tornar "true" o atributo "ativo" do usuário via API
    async function handleEnableUser(id) {
        const response = await enableUserService(id);
        if (response) {
            handleRefreshUsers();
        }
    }



    //--------------- RETORNO DO COMPONENTE CONTAINER CREATE COMPANY ---------------//
    return (
        <>

            {/* DIV QUE CONTÊM OS USUÁRIOS */}
            <div className="bg-surface-2 rounded-xl overflow-hidden shadow border border-white/[0.08]">

                {/* TABELA */}
                <table className="w-full text-xs lg:text-sm table-fixed">

                    {/* CABEÇALHO DA TABELA */}
                    <thead className="bg-surface-3">
                        <tr>
                            <th className="p-3 w-[30%] sm:w-[25%] lg:w-[15%] truncate text-left">Nome</th>
                            <th className="p-3 w-[30%] sm:w-[30%] lg:w-[30%] truncate text-left">Email</th>
                            <th className="p-3 w-[40%] sm:w-[30%] lg:w-[15%] truncate text-left">Empresa</th>
                            <th className="p-3 lg:w-[10%] text-left hidden lg:table-cell">Criado em</th>
                            <th className="p-3 lg:w-[30%] text-left hidden lg:table-cell">Ações</th>
                        </tr>
                    </thead>

                    {/* CORPO DA TABELA */}
                    <tbody>
                        {users.map((usuario) => (
                            <>

                                {/* LINHA COM AS CÉLULAS NOME, EMAIL, EMPRESA, DATA DE CRIAÇÃO E AÇÕES*/}
                                <tr key={usuario.id} className="lg:border-b lg:border-white/[0.08]">
                                    <td className="p-3 w-[30%] sm:w-[25%] lg:w-[15%] truncate">{usuario.nome}</td>
                                    <td className="p-3 w-[30%] sm:w-[30%] lg:w-[30%] truncate">{usuario.email}</td>
                                    <td className="p-3 w-[40%] sm:w-[30%] lg:w-[15%] truncate">{usuario.nome_empresa}</td>

                                    {/* AS CÉLUlAS DATA DE CRIAÇÃO E AÇÕES SÓ APARECEM EM TELAS COM LARGURA IGUAL OU SUPERIOR A 1024px */}
                                    <td className="p-3 hidden lg:w-[10%] lg:table-cell ">{new Date(usuario.data_criacao).toLocaleDateString()}</td>
                                    <td className="p-3 hidden lg:w-[30%] lg:table-cell">

                                        {/* BUTTONS DE AÇÃO PARA COMPUTADORES (LARGURA SUPERIOR A 1024px) */}
                                        <div className="flex flex-row gap-2 ">
                                            <button
                                                onClick={() => handleOpenModal(usuario, true)}
                                                className="bg-yellow-600 hover:bg-yellow-700 px-3 py-1 rounded"
                                            >
                                                Senha
                                            </button>
                                            <button
                                                onClick={() => handleOpenModal(usuario)}
                                                className="bg-blue-600 hover:bg-blue-700 px-3 py-1 rounded"
                                            >
                                                Editar
                                            </button>
                                            <button
                                                onClick={() => { usuario.ativo ? handleDisableUser(usuario.id) : handleEnableUser(usuario.id) }}
                                                className={usuario.ativo ? "bg-red-600 hover:bg-red-700 px-3 py-1 rounded" : "bg-green-600 hover:bg-green-700 px-4 py-1 rounded"}
                                            >
                                                {usuario.ativo ? "Inativar" : "Ativar"}
                                            </button>
                                        </div>
                                    </td>
                                </tr>

                                {/* LINHA COM A CÉLULA AÇÕES (LARGURA INFERIOR A 1024px) */}
                                <tr className="lg:hidden border-b border-white/[0.08]">
                                    <td colSpan={3} className="p-3">

                                        {/* BUTTONS DE AÇÃO PARA SMARTPHONES E TABLETS (LARGURA INFERIOR A 1024px) */}
                                        <div className="flex flex-row gap-2 items-center text-right">
                                            <p className="mr-auto truncate">Criado em: {new Date(usuario.data_criacao).toLocaleDateString()}</p>
                                            <button
                                                onClick={() => handleOpenModal(usuario, true)}
                                                className="bg-yellow-600 hover:bg-yellow-700 px-4 py-1 rounded"
                                            >
                                                Senha
                                            </button>
                                            <button
                                                onClick={() => handleOpenModal(usuario)}
                                                className="bg-blue-600 hover:bg-blue-700 px-4 py-1 rounded"
                                            >
                                                Editar
                                            </button>
                                            <button
                                                onClick={() => { usuario.ativo ? handleDisableUser(usuario.id) : handleEnableUser(usuario.id) }}
                                                className={usuario.ativo ? "bg-red-600 hover:bg-red-700 px-3 py-1 rounded" : "bg-green-600 hover:bg-green-700 px-4 py-1 rounded"}
                                            >
                                                {usuario.ativo ? "Inativar" : "Ativar"}
                                            </button>

                                        </div>

                                    </td>
                                </tr>
                            </>
                        ))}

                    </tbody>

                </table>

            </div>

        </>
    )
}